import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import s from './s.module.less';
import { TFaqMgmt } from '../../../type';

interface Props {
    index: number;
    faq: TFaqMgmt;
    onEdit?: (faq: TFaqMgmt) => void;
    onRemove?: (faq: TFaqMgmt) => void;
}

const FAQItem: React.FC<Props> = ({ faq, index, onEdit, onRemove }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: (faq as any)._tempId || faq.question,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        boxShadow: isDragging ? '0 4px 12px rgba(0,0,0,0.1)' : 'none',
    };

    return (
        <div ref={setNodeRef} style={style} className={s.card}>
            <div className={s.header} {...attributes}>
                <div className={s.title}>
                    <span className={s.dragHandle} {...listeners}><MenuOutlined /></span>
                    FAQ {index + 1}
                </div>
                <div className={s.buttons}>
                    <Button
                        type="text"
                        className={s.removeButton}
                        onClick={(e) => {
                            e.stopPropagation();
                            console.log('FAQ Remove button clicked:', faq.question);
                            onRemove?.(faq);
                        }}
                    >
                        Remove
                    </Button>
                    <Button
                        onClick={(e) => {
                            e.stopPropagation();
                            console.log('FAQ Edit button clicked:', faq.question);
                            onEdit?.(faq);
                        }}
                    >
                        Edit
                    </Button>
                </div>
            </div>
            <div className={s.content}>
                <div className={s.field}>
                    <div className={s.label}>Question</div>
                    <div className={s.value}>{faq?.question || '-'}</div>
                </div>
                <div className={s.field}>
                    <div className={s.label}>Answer</div>
                    <div className={s.value}>{faq?.answer || '-'}</div>
                </div>
            </div>
        </div>
    );
};

export default FAQItem;
